import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiCheckCircle, FiDownload, FiSettings, FiPlayCircle } = FiIcons;

const Implementation = () => {
  const timeline = [
    {
      days: 'Days 1–2',
      title: 'Intake & Data Collection',
      desc: 'Access provisioning, audit of current assets, and tool connections.',
      icon: FiDownload,
      color: 'blue'
    },
    {
      days: 'Days 3–5',
      title: 'SOP Extraction',
      desc: 'Interviewing team to document "tribal knowledge" into the SOP Library.',
      icon: FiCheckCircle,
      color: 'emerald'
    },
    {
      days: 'Days 6–8',
      title: 'Dashboard & Reporting Build',
      desc: 'Configuring the Command Center and Reporting Suite templates.',
      icon: FiSettings,
      color: 'purple'
    },
    {
      days: 'Days 9–11',
      title: 'Automations Setup',
      desc: 'Implementing Zapier workflows for asset requests and notifications.',
      icon: FiSettings,
      color: 'orange'
    },
    {
      days: 'Days 12–14',
      title: 'Testing & Onboarding',
      desc: 'Final QA of the system and training sessions with the Coordinator.',
      icon: FiPlayCircle,
      color: 'emerald'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Implementation Timeline: 14 Days</h1>
        <p className="text-lg text-gray-600">
          A rapid deployment plan to get your system live and your coordinator productive in just two weeks.
        </p>
      </motion.div>

      <div className="relative">
        {/* Vertical Line */}
        <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gray-200 hidden md:block"></div>

        <div className="space-y-8">
          {timeline.map((phase, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="relative flex flex-col md:flex-row items-start md:items-center"
            >
              {/* Timeline Dot */}
              <div className={`hidden md:flex absolute left-8 -translate-x-1/2 w-4 h-4 rounded-full border-2 border-white ring-2 ring-${phase.color}-500 bg-${phase.color}-500`}></div>

              {/* Card */}
              <div className="ml-0 md:ml-16 glass-card p-6 rounded-xl w-full hover:shadow-md transition-shadow border-l-4 border-emerald-500">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm font-bold mr-4">
                      {phase.days}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900">{phase.title}</h3>
                  </div>
                  <SafeIcon icon={phase.icon} className={`w-6 h-6 text-${phase.color}-500 opacity-50`} />
                </div>
                <p className="text-gray-600 ml-1">{phase.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Implementation;